<h1 class="h1-margin">{{pageData?.refunded?.heading}}</h1>
<br>
<div>
  <a routerLink="/refund/status/lookup" >
<< {{pageData?.refunded?.backToSearch}} <span aria-hidden="true"></span>
</a>
</div>
<br>

<!-- Unnamed (Rectangle) -->
<div *ngIf="isCCFOP">
  <div id="calloutHeadingInfo" class="callout primary standard-margin-bottom"
  aria-labelledby="calloutHeadingInfo">
    <h2 class="callout-padding text-gray" aria-live="assertive">{{pageData?.refunded?.ccInfoHeading}}</h2>
    <p>{{pageData?.refunded?.ccInfoMessage}}</p>
  </div>
  <br>
</div>
<!-- Unnamed (Rectangle) -->

<!-- loop through the refund status list -->
<div *ngFor="let refundStatus of refundStatusRs.refundStatus">
  <div class="card">
    <div class="card-section-padding">
      <div *ngIf="refundStatus.isTransportTicket && refundStatus.scitDetails.sciDestinationCityState !== null">
        <h2 class="h2-margin">{{pageData?.refunded?.yourTripTo}} {{refundStatus.scitDetails.sciDestinationCityState}}</h2>
        <h3 id="cardHeadingId">{{refundStatus.scitDetails.sciUseDate | localizedDate:'fullDate' | capitalizeFirst}}</h3>
      </div>
      <div *ngIf="!refundStatus.isTransportTicket && refundStatus.tripCreditInd === 'Y'">
        <h2 class="h2-margin">{{pageData?.refunded?.tripCredit}}</h2>
      </div>
      <div *ngIf="!refundStatus.isTransportTicket && refundStatus.tripCreditInd === 'N'">
        <div [ngSwitch]="refundStatus.productDescription">
          <div *ngSwitchCase="'INSTANT UPSELL'">
            <h2 class="h2-margin">{{pageData?.refunded?.instantUpsell}}</h2>
          </div>
          <div *ngSwitchCase="'Prepaid Bags'">
            <h2 class="h2-margin">{{pageData?.refunded?.prepaidBags}}</h2>
          </div>
          <div *ngSwitchCase="'Mileage Reinstatement Fee'">
            <h2 class="h2-margin">{{pageData?.refunded?.mileReinstatementfee}}</h2>
          </div>
          <div *ngSwitchCase="'Group Deposits'">
            <h2 class="h2-margin">{{pageData?.refunded?.groupDeposits}}</h2>
          </div>
          <div *ngSwitchDefault>
            <h2 class="h2-margin">{{pageData?.refunded?.yourTrip}}</h2>
          </div>
        </div>
      </div>
      <div *ngIf="(!refundStatus.isTransportTicket || refundStatus.scitDetails.sciDestinationCityState === null) && refundStatus.tripCreditInd === null">
        <div [ngSwitch]="refundStatus.productDescription">
          <div *ngSwitchCase="'AWARD MAIN CABIN EXTRA'">
            <h2 class="h2-margin">{{pageData?.refunded?.mainCabinExtra}} ({{refundStatus.scitDetails.sciOrigin}}-{{refundStatus.scitDetails.sciDestination}})</h2>
          </div>
          <div *ngSwitchCase="'MAIN CABIN EXTRA'">
            <h2 class="h2-margin">{{pageData?.refunded?.mainCabinExtra}} ({{refundStatus.scitDetails.sciOrigin}}-{{refundStatus.scitDetails.sciDestination}})</h2>
          </div>
          <div *ngSwitchCase="'AWARD PREFERRED SEATS'">
            <h2 class="h2-margin">{{pageData?.refunded?.preferredSeat}} ({{refundStatus.scitDetails.sciOrigin}}-{{refundStatus.scitDetails.sciDestination}})</h2>
          </div>
          <div *ngSwitchCase="'PREFERRED SEATS'">
            <h2 class="h2-margin">{{pageData?.refunded?.preferredSeat}} ({{refundStatus.scitDetails.sciOrigin}}-{{refundStatus.scitDetails.sciDestination}})</h2>
          </div>
          <div *ngSwitchDefault>
            <h2 class="h2-margin">{{pageData?.refunded?.yourTrip}} <span *ngIf="refundStatusRs.refundStatus[0].scitDetails.sciOrigin && refundStatusRs.refundStatus[0].scitDetails.sciDestination">({{refundStatusRs.refundStatus[0].scitDetails.sciOrigin}}-{{refundStatusRs.refundStatus[0].scitDetails.sciDestination}})</span></h2>
          </div>
        </div>
        <br>
      </div>
      <div class="card-section-background">
        <div class="card-section">
          <div class="grid-x grid-margin-x">
            <div class="cell small-6 align-text-left">
              <div *ngIf="refundStatus.tripCreditInd === 'Y'; else elseBlock"> 
                <b>{{pageData?.refunded?.tripCreditNumber}} {{refundStatus.ticketNumber}}</b>
              </div>
              <ng-template #elseBlock>
                <b>{{pageData?.refunded?.ticketNumber}} {{refundStatus.ticketNumber}}</b>
              </ng-template>
            </div>
            <div *ngIf="isUSD && refundStatus.refundStatusMessageCode !== 'CM'  && refundStatus.refundStatusMessageCode !== 'GC'" class="cell small-6 align-text-right padding-text-right">
              <span class="refund-amount">${{refundStatus.refundAmount | number: '1.2-2'}}</span>
            </div>
            <div *ngIf="!isUSD && refundStatus.refundStatusMessageCode !== 'CM' && refundStatus.refundStatusMessageCode !== 'GC'" class="cell small-6 align-text-right padding-text-right">
              <span class="refund-amount">{{refundStatus.refundCurrency}} {{refundStatus.refundAmount | number: '1.2-2'}}</span>
            </div>
          </div>
          <div [ngSwitch]="refundStatus.refundStatusMessageCode" class="grid-x grid-margin-x">
            <div *ngSwitchCase="'AA'" class="cell medium-6 large-8 align-text-left">
              {{pageData?.refunded?.processedOn}} {{refundStatus.refundDate | localizedDate:'fullDate' | capitalizeFirst}}
              &nbsp; &bull; &nbsp; {{pageData?.refunded?.aaMessage}}{{refundStatus.cardEnding}}
            </div>
            <div *ngSwitchCase="'AX'" class="cell medium-6 large-8 align-text-left">
              {{pageData?.refunded?.processedOn}} {{refundStatus.refundDate | localizedDate:'fullDate' | capitalizeFirst}}
              &bull; &nbsp; {{pageData?.refunded?.axMessage}}{{refundStatus.cardEnding}}
            </div>
            <div *ngSwitchCase="'DC'" class="cell medium-6 large-8 align-text-left">
              {{pageData?.refunded?.processedOn}} {{refundStatus.refundDate | localizedDate:'fullDate' | capitalizeFirst}}
              &bull; &nbsp; {{pageData?.refunded?.dcMessage}}{{refundStatus.cardEnding}}
            </div>
            <div *ngSwitchCase="'DS'" class="cell medium-6 large-8 align-text-left">
              {{pageData?.refunded?.processedOn}} {{refundStatus.refundDate | localizedDate:'fullDate' | capitalizeFirst}}
              &bull; &nbsp; {{pageData?.refunded?.dsMessage}}{{refundStatus.cardEnding}}
            </div>
            <div *ngSwitchCase="'JC'" class="cell medium-6 large-8 align-text-left">
              {{pageData?.refunded?.processedOn}} {{refundStatus.refundDate | localizedDate:'fullDate' | capitalizeFirst}}
              &bull; &nbsp; {{pageData?.refunded?.jcMessage}}{{refundStatus.cardEnding}}
            </div>
            <div *ngSwitchCase="'MC'" class="cell medium-6 large-8 align-text-left">
              {{pageData?.refunded?.processedOn}} {{refundStatus.refundDate | localizedDate:'fullDate' | capitalizeFirst}}
              &bull; &nbsp; {{pageData?.refunded?.mcMessage}}{{refundStatus.cardEnding}}
            </div>
            <div *ngSwitchCase="'VI'" class="cell medium-6 large-8 align-text-left">
              {{pageData?.refunded?.processedOn}} {{refundStatus.refundDate | localizedDate:'fullDate' | capitalizeFirst}}
              &bull; &nbsp; {{pageData?.refunded?.viMessage}}{{refundStatus.cardEnding}}
            </div>
            <div *ngSwitchCase="'UATP'" class="cell medium-6 large-8 align-text-left">
              {{pageData?.refunded?.processedOn}} {{refundStatus.refundDate | localizedDate:'fullDate' | capitalizeFirst}}
              &bull; &nbsp; {{pageData?.refunded?.uatpMessage}}{{refundStatus.cardEnding}}
            </div>
            <div *ngSwitchCase="'ORIGINAL_FOP'" class="cell medium-6 large-8 align-text-left">
              {{pageData?.refunded?.processedOn}} {{refundStatus.refundDate | localizedDate:'fullDate' | capitalizeFirst}}
              &bull; &nbsp; {{pageData?.refunded?.originalFOPMessage}}
            </div>
            <div *ngSwitchCase="'PP'" class="cell medium-6 large-8 align-text-left">
              {{pageData?.refunded?.processedOn}} {{refundStatus.refundDate | localizedDate:'fullDate' | capitalizeFirst}}
              &bull; &nbsp; {{pageData?.refunded?.ppMessage}}
            </div>
            <div *ngSwitchCase="'WC'" class="cell medium-6 large-8 align-text-left">
              {{pageData?.refunded?.processedOn}} {{refundStatus.refundDate | localizedDate:'fullDate' | capitalizeFirst}}
              &bull; &nbsp; {{pageData?.refunded?.wcMessage}}
            </div>
            <div *ngSwitchCase="'CU'" class="cell medium-6 large-8 align-text-left">
              {{pageData?.refunded?.processedOn}} {{refundStatus.refundDate | localizedDate:'fullDate' | capitalizeFirst}}
              &bull; &nbsp; {{pageData?.refunded?.cuMessage}}
            </div>
            <div *ngSwitchCase="'AL'" class="cell medium-6 large-8 align-text-left">
              {{pageData?.refunded?.processedOn}} {{refundStatus.refundDate | localizedDate:'fullDate' | capitalizeFirst}}
              &nbsp; &bull; &nbsp; {{pageData?.refunded?.alMessage}}
            </div>
            <div *ngSwitchCase="'VC'" class="cell medium-6 large-8 align-text-left">
              <ng-container *ngIf="isBeforeCutoffDate(refundStatus.refundDate)">
                {{pageData?.refunded?.processedOn}} {{refundStatus.refundDate | localizedDate:'fullDate' | capitalizeFirst}}
                &bull; &nbsp; {{pageData?.refunded?.vcMessageVoucher}} 
              </ng-container>              
              <ng-container *ngIf="!isBeforeCutoffDate(refundStatus.refundDate)">
                {{pageData?.refunded?.processedOn}} {{refundStatus.refundDate | localizedDate:'fullDate' | capitalizeFirst}}
                &bull; &nbsp; {{pageData?.refunded?.vcMessage}} 
              </ng-container>              
            </div>
            <div *ngSwitchCase="'GC'" class="cell medium-6 large-8 align-text-left">
              {{pageData?.refunded?.processedOn}} {{refundStatus.refundDate | localizedDate:'fullDate' | capitalizeFirst}}
              &bull; &nbsp; {{pageData?.refunded?.gcMessage}}
            </div>
            <div *ngSwitchCase="'CM'" class="cell medium-6 large-8 align-text-left">
              {{pageData?.refunded?.processedOn}} {{refundStatus.refundDate | localizedDate:'fullDate' | capitalizeFirst}}
              &bull; &nbsp; {{pageData?.refunded?.cmMessage}}
            </div>
            <div *ngSwitchCase="'CK'" class="cell medium-6 large-8 align-text-left">
              {{pageData?.refunded?.processedOn}} {{refundStatus.refundDate | localizedDate:'fullDate' | capitalizeFirst}}
              &bull; &nbsp; {{pageData?.refunded?.ckMessage}}{{refundStatus.refundDate | localizedDate:'fullDate' | capitalizeFirst}}
            </div>
            <div *ngSwitchCase="'BT'" class="cell medium-6 large-8 align-text-left">
              {{pageData?.refunded?.btMessage}}
            </div>
            <div *ngSwitchCase="'IC'" class="cell medium-6 large-8 align-text-left">
              {{pageData?.refunded?.processedOn}} {{refundStatus.refundDate | localizedDate:'fullDate' | capitalizeFirst}}
              &bull; &nbsp; {{pageData?.refunded?.icMessage}}
            </div>
            <div *ngIf="refundStatus.refundStatusMessageCode !== 'GC'" class="cell medium-6 large-4 align-text-right padding-text-right"><span class="tag-success">&nbsp;&nbsp;{{pageData?.refunded?.status}}&nbsp;&nbsp;</span></div>
          </div>
          <hr *ngIf="isEmailProvided">
            <p *ngIf="isEmailProvided">{{pageData?.refunded?.emailMessage}} <span class="link-blue">{{refundStatus.passengerContact.email | lowercase}}</span>.</p>
        </div>
      </div>
    </div>
  </div>
</div>
<br>
<div class="list-style standard-margin-bottom">
  <h3 id="refundHeading">{{pageData?.refunded?.refundInformation}}</h3>
  <ul aria-labelledby="refundHeading">
    <li>{{pageData?.refunded?.refundInformation2}}</li>
    <li>{{pageData?.refunded?.refundInformation3}}</li>
    <li>{{pageData?.refunded?.refundInformation4}}</li>
  </ul>
</div>

<router-outlet></router-outlet>